import React, {Component} from 'react';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';

import LoginWithGoogle from './login/LoginWithGoogle';

import GA from 'lib/ga';
import I18n from 'lib/i18n/i18n';
import defaultCallback from 'lib/defaultCallback';

import { isJewelers, rootUrl, sellerDashboardUrl } from 'helpers/ApplicationHelper';
import SellItemWizard from 'components/sellItemWizard';

import {performLogIn, sendCode} from 'actions/logIn';
import {updateReferrer} from 'actions/pendingItem';
import {updateSubmissionProgressState} from 'actions/submissionProgress';
import ReactScroll from "react-scroll/modules";
import {isMobile, widgetEventDispatcher} from "../helpers/ApplicationHelper";
import { LargePrimaryButton, LargeSecondaryButton, Validator } from "@worthy-npm/clarity";
import { EmailInput, NumberInput } from '@worthy-npm/clarity'
import Validators from "../lib/validators";
import { sellerDashboardEnabled } from '../helpers/gbExperiment';
import cookie from 'react-cookie';

const NUMBER_OF_CODE_DIGITS = 4
class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            digits: [],
            codeSent: false,
            email: '',
            codeValue: '',
        };
        this.digitsRefs = []
        for (let index = 0 ; index < NUMBER_OF_CODE_DIGITS ; index++) {
            this.state.digits.push(null)
            this.digitsRefs.push(React.createRef())
        }
    }

    componentDidMount() {
        this.props.updateSubmissionProgressState('login');
        const bundleId = this.props && this.props.location && this.props.location.query && this.props.location.query.bundle;
        let redirectTo = this.props && this.props.redirectTo || (this.props.location && this.props.location.state && this.props.location.state.redirectTo);
        if(redirectTo) {
            this.state.onLoginSuccessful = () => {
                window.location = rootUrl(redirectTo);
                return;
            };
            return;
        }

        if (this.props.onSubmitForm) {
            this.state.onSubmitForm = this.props.onSubmitForm;
        }

        if (this.props.onLoginSuccessful != defaultCallback) {
            this.state.onLoginSuccessful = this.props.onLoginSuccessful;
        } else if (this.props.pendingItem || this.props.jewelryBox || bundleId) {
            this.state.onLoginSuccessful = () => {

                if (isJewelers(this.props.session)){
                    window.location = rootUrl('/jewelers');
                    return;
                }

                let component = this.props.logIn;
                if (this.props.pendingItem) {
                    GA.itemSubmissionSuccessfully();
                    browserHistory.push('/item/' + this.props.item.id);
                }

                else if (this.props.jewelryBox || bundleId) {
                    window.location.pathname = `/multiple_jewelry/${bundleId || this.props.jewelryBox.bundle_id}`;
                }
            }
        } else if (this.props.onLoginSuccessful == defaultCallback){
            this.state.onLoginSuccessful = () => {
                this.onSuccess();
            }
        }

        GA.loginFormPresented();

        ReactScroll.animateScroll.scrollTo(0, {
            duration: 0,
            delay: 0,
            smooth: true
        });
    }

    componentWillUnmount() {
        this.props.updateSubmissionProgressState();
        if(this.props.pendingItem){
            this.props.updateReferrer('loginForm');
        }
    }

    componentWillReceiveProps({session}){
        if(session && session.isLoggedIn){
            let redirectTo = this.props && this.props.redirectTo || (this.props.location && this.props.location.state && this.props.location.state.redirectTo);
            if(redirectTo)
                window.location = rootUrl(redirectTo);
            return;
        }
    }

    onSuccess() {
        const experimentSellerDashboard = sellerDashboardEnabled();

        if (experimentSellerDashboard) {
            const newURL = new URL(sellerDashboardUrl('/'));
            const uvid = cookie.load('uvid');
            if (uvid) {
                newURL.searchParams.set('uvid', uvid);
            }
            window.location.href = newURL.toString();
            return;
        }
        window.location = rootUrl('/');
        return;
    }

    loginSuccessful() {
        GA.loginFormSuccessfully();
        this.state.onLoginSuccessful();
    }

    loginWithGoogleSuccessfully(){
        GA.loginWithGoogleSuccessfully()
        this.loginSuccessful()
    }

    renderWizard = () => {
        if(this.props.pendingItem){
            return (<SellItemWizard step={2} registerText={I18n.getString('common::sellItemWizard::stepSignIn')} />);
        }
    }

    setError(error) {
        this.setState({ validationMessage: error})
    }

    title() {
        return <div className="login-form-title">Log In</div>
    }

    emailInputRenderer() {
        return <EmailInput
            label="Email"
            initialValue={this.state.email || ''}
            change={(value) => {
                this.setState({
                    email: value,
                    isValid: Validators.validateEmail(value),
                    validationMessage: null
                })
            }}
            overrideCSS={{
                font: '300 16px Roboto',
                focus: { borderColor: '#2D5DEC' },
                hover: { borderColor: '#2D5DEC'}
            }}
            forceValidationMessage={this.state.validationMessage}
            autoFocus
            />
    }

    handlePaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData && e.clipboardData.getData ? 
            e.clipboardData.getData('text').replace(/\D/g, '').slice(0, NUMBER_OF_CODE_DIGITS) : '';
        
        if (pastedData.length > 0) {
            // Create a new digits array with empty values first
            const digits = Array(NUMBER_OF_CODE_DIGITS).fill(null);
            
            // Fill in the digits from the pasted data
            for (let i = 0; i < pastedData.length; i++) {
                digits[i] = pastedData[i];
            }
            
            // Single setState call with all updates
            const tCode = digits.filter(d => d !== null).join('');
            this.setState({ 
                codeValue: tCode, 
                digits, 
                validationMessage: null 
            }, () => {
                // Focus the last field or the next empty field
                const focusIndex = Math.min(pastedData.length, NUMBER_OF_CODE_DIGITS) - 1;
                if (this.digitsRefs[focusIndex] && this.digitsRefs[focusIndex].current) {
                    this.digitsRefs[focusIndex].current.focus();
                }
            });
        }
    };

    codeInputRenderer() {
        if (!isMobile()) {
            const updateCode = (value, index) => {
                const digits = [...this.state.digits]
                digits[index] = value
                const tCode = digits.filter((c) => !!c).join('')
                this.setState( { codeValue: tCode, digits, validationMessage: null })
                if (value.length) {
                    if (index < NUMBER_OF_CODE_DIGITS - 1) {
                        this.digitsRefs[index+1].current.focus()
                    } else {
                        this.digitsRefs[index].current.blur()
                    }
                }
            }

            const handleKeyDown = (e, index) => {
                // Handle backspace to go to previous field
                if (e.key === 'Backspace') {
                    const newDigits = [...this.state.digits];
                    
                    if (!e.target.value) {
                        // If current field is empty, clear previous field
                        const prevIndex = index - 1;
                        if (prevIndex >= 0 && this.digitsRefs[prevIndex].current) {
                            newDigits[prevIndex] = null;
                            this.setState({
                                digits: newDigits,
                                codeValue: newDigits.filter(d => d !== null).join('')
                            }, () => {
                                // Focus the previous field after state update
                                this.digitsRefs[prevIndex].current.focus();
                            });
                        }
                    } else {
                        // If current field has content, clear it
                        newDigits[index] = null;
                        this.setState({
                            digits: newDigits,
                            codeValue: newDigits.filter(d => d !== null).join('')
                        }, () => {
                            // Move to previous field if available
                            const prevIndex = index - 1;
                            if (prevIndex >= 0 && this.digitsRefs[prevIndex].current) {
                                this.digitsRefs[prevIndex].current.focus();
                            }
                        });
                    }
                }
                
                // Handle right arrow key to go to next field
                if (e.key === 'ArrowRight' && index < NUMBER_OF_CODE_DIGITS - 1) {
                    this.digitsRefs[index + 1].current.focus();
                }
                
                // Handle left arrow key to go to previous field
                if (e.key === 'ArrowLeft' && index > 0) {
                    this.digitsRefs[index - 1].current.focus();
                }
            };

            const inputs = [];
            let { validationMessage } = this.state;
            for (let i = 0; i < NUMBER_OF_CODE_DIGITS; i++) {
                inputs.push(
                  <input type='text'
                         inputMode='numeric'
                         pattern='[0-9]'
                         ref={this.digitsRefs[i]}
                         maxLength={1}
                         autoFocus={i === 0}
                         key={i}
                         name={`${i}`}
                         value={this.state.digits[i] || ''}
                         className={`code-4-digits ${validationMessage ? 'border-error shake-error' : ''}`}
                         onChange={(e) => updateCode(e.target.value, i)}
                         onPaste={this.handlePaste}
                         onKeyDown={(e) => handleKeyDown(e, i)}
                         onFocus={(e) => e.target.select()}
                  />
                )
            }
            return(
              <div className='align-center'>
                  {inputs}
                  <div className={'login-error' + (this.state.validationMessage ? '' : ' hidden')}>{this.state.validationMessage}</div>
              </div>
            )
        } else {
            return <NumberInput
            autocomplete='one-time-password'
            change={(value) => this.setState({ codeValue: value }) }
            overrideCSS={{
                font: '300 16px Roboto',
                focus: { borderColor: '#2D5DEC' },
                hover: { borderColor: '#2D5DEC'}
            }}
            label="One Time Code"
            forceValidationMessage={this.state.validationMessage}
            showValidationMessage={!!this.state.validationMessage}
            autoFocus
        />
        }
    }

    requestCode(medium, stopAnimation) {
        medium = medium || this.state.medium
        // is valid?
        if (!this.state.isValid) {
            let validator = new Validator(this.state.email);
            validator.isEmail().isEmailEmpty();
            this.setError(validator.validationMessage)
            if (stopAnimation) stopAnimation()
            return
        }
        this.setState({ validationMessage: undefined })
        this.props.sendCode({ medium, email: this.state.email, requestId: this.state.requestId})
            .then((res) => {
                if (res.payload.status === 200) {
                    if (res.payload.data.prettyError) {
                        this.setError(res.payload.data.prettyError)
                    } else {
                        this.setState({
                            codeSent: true,
                            medium,
                            requestId: res.payload.data.request_id,
                            phone: `***-***-${res.payload.data.phone}`
                        })
                    }
                } else {
                    const errors = {
                        404: "Email doesn't exist in our system. <a href='/register' class='blue'>Register</a>",
                        500: "Something went wrong. Please try later."
                    }
                    this.setError(errors[res.payload._errorCodesList[0]])
                }
            }).finally(stopAnimation)
    }
    sendCodeButtonsRenderer() {
        const buttonOverride = { borderRadius: '3px', width: '100%', padding: '11px 22px 12px', border:'none' }
        return <div>
            <LargePrimaryButton
                text="Send code to my email"
                click={(stopAnimation) => {
                    GA.LoginFormEvents.emailOTPClicked()
                    this.requestCode('email', stopAnimation)
                }}
                overrideWrapperCSS={{ display:'block', marginBottom:'12px' }}
                overrideCSS={buttonOverride}
            />
            <LargeSecondaryButton
                text="Send code to my phone"
                click={(stopAnimation) => {
                    GA.LoginFormEvents.phoneOTPClicked()
                    this.requestCode('sms', stopAnimation)
                }}
                overrideWrapperCSS={{display:'block' }}
                overrideCSS={buttonOverride}
            />
        </div>
    }

    codeScreenButtonsRenderer() {
        const buttonOverride = { borderRadius: '3px', width: '100%', padding: '11px 22px 12px', font: '500 16px Roboto' }
        return <div>
            <LargePrimaryButton
                text="Log in"
                disabled={ this.state.codeValue.length < NUMBER_OF_CODE_DIGITS }
                click={(stopAnimation) => {
                    GA.LoginFormEvents.loginClicked()
                    this.state.onSubmitForm ? this.state.onSubmitForm() : null;
                    this.props.performLogIn({
                        otp_code: this.state.codeValue,
                        email: this.state.email,
                        request_id: this.state.requestId,
                        medium: this.state.medium,
                    }).then((res) => {
                        if (!res.error) {
                            this.loginSuccessful();
                        } else {
                            const errors = {
                                400: res.payload._data,
                                401: 'Invalid code',
                                500: 'Something went wrong. Please try later'
                            }
                            this.setError(errors[res.payload._errorCodesList[0]])
                        }

                    },() => widgetEventDispatcher('login-error')
                    ).finally(stopAnimation)
                }}
                overrideWrapperCSS={{ display:'block', marginBottom:'12px' }}
                overrideCSS={buttonOverride}
            />
            <LargeSecondaryButton
                text="Resend code"
                click={(stopAnimation) => {
                    GA.LoginFormEvents.resendCodeClicked()
                    this.setState({ codeSent: false, validationMessage: null }, stopAnimation)
                }}
                overrideWrapperCSS={{display:'block' }}
                overrideCSS={buttonOverride}
            />
        </div>
    }

    loginFormScreen(topText, boldText, inputRenderer, buttonsRenderer) {
        return <div className="login-form-area">
            <div className="login-form-top-text">{topText} <span>{boldText}</span></div>
            <div className="login-form-input-area">{inputRenderer()}</div>
            <div className="login-form-buttons">{buttonsRenderer()}</div>
        </div>
    }

    emailScreen() {
        return this.loginFormScreen(I18n.getString('logIn::emailScreen::topText'),
            I18n.getString('logIn::emailScreen::boldText'),
            this.emailInputRenderer.bind(this),
            this.sendCodeButtonsRenderer.bind(this))
    }

    codeScreen() {
        return this.loginFormScreen(I18n.getString('logIn::codeScreen::topText'),
            this.state.medium === 'email' ? this.state.email : this.state.phone,
            this.codeInputRenderer.bind(this),
            this.codeScreenButtonsRenderer.bind(this))
    }

    newHere() {
        return <div className='new-here'>{I18n.getString('logIn::newHere')} &nbsp;
            <a className="blue" onClick={() => browserHistory.push('/register')}>
                {I18n.getString('logIn::register')}
            </a>
        </div>
    }

    assistance() {
        return <div className='assistance-text'>{I18n.getString('logIn::assistanceText')} &nbsp;
            <a className="blue" href={`tel:${I18n.getString('common::phoneNumber')}}`}>{I18n.getString('common::phoneNumberString')}</a>
        </div>
    }

    loginBox() {
        return <div className="login-box">
            {this.title()}
            <LoginWithGoogle onSuccessfulLogin={this.loginWithGoogleSuccessfully.bind(this)}/>
            { this.state.codeSent ? this.codeScreen() : this.emailScreen() }
        </div>
    }
    render() {
        return <div className="login-container-otp">
            {this.renderWizard()}
            {this.loginBox()}
            {this.newHere()}
            {this.assistance()}
        </div>
    }
}

Login.propTypes = Object.assign({
    onLoginSuccessful: PropTypes.func,
    onSubmitForm: PropTypes.func,
    sendCode: PropTypes.func,
    showLinkToRegister: PropTypes.bool
}, Login.propTypes);

Login.defaultProps = {
    onLoginSuccessful: defaultCallback,
    showLinkToRegister: true
};

const mapStateToProps = ({Session, LogIn, PendingItem, PendingJewelryBox, Item, JewelryBox}) => {
    return {
        session: Session,
        logIn: LogIn,
        pendingItem: PendingItem,
        pendingJewelryBox: PendingJewelryBox,
        item: Item,
        jewelryBox: JewelryBox
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({performLogIn, sendCode, updateReferrer, updateSubmissionProgressState}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
